import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import { useEffect, useState } from 'react'

const StudentView: React.FC = () => {
  const location = useLocation()
  const [playerGameLink, setPlayerGameLink] = useState(false)

  useEffect(() => {
    const pattern = new RegExp(
      /^\/player-dashboard\/[A-Z0-9]+(\/player|\/charter\/(prep|group))$/
    )
    setPlayerGameLink(pattern.test(location.pathname))
  }, [location.pathname])

  return (
    <div className='h-screen flex flex-col'>
      {!playerGameLink && <Navbar />}
      <div className='flex-grow overflow-auto min-h-0'>
        <Outlet />
      </div>
    </div>
  )
}

export default StudentView
